import { Category } from '@modules/common/types';
import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';
import { FeedbackMetaData } from 'v2/store/useViewFeedbackStore';

interface getSelectedCategoryLabelsOptions {
  selectedLabels: FeedbackLabel[];
  category: Category;
  selectedFeedbackMetadata?: FeedbackMetaData[];
}

export const getSelectedCategoryLabels = ({
  selectedLabels,
  category,
  selectedFeedbackMetadata,
}: getSelectedCategoryLabelsOptions) => {
  return selectedLabels.filter((selectedLabel) => {
    if (
      selectedLabel.type === FeedbackLabelType.Entity &&
      selectedFeedbackMetadata?.length
    ) {
      return selectedFeedbackMetadata?.some(
        (feedbackMetadata) =>
          feedbackMetadata.id === selectedLabel.id &&
          (feedbackMetadata.category === category ||
            feedbackMetadata.category === undefined),
      );
    }
    return true;
  });
};
